<template>
  <v-container>
    <v-layout justify-center>
      <v-flex
        md12
        lg10
        :style="{ width: '90vw', margin: 'auto', textAlign: 'center' }"
      >
        <v-card color="primary" class="ma-auto" flat>
          <UserSearch
            ref="userSearch"
            v-if="reload"
            class="pa-4 my-4 mx-auto"
            @employee-selected="userSelected"
          />

          <v-btn outline color="success" class="mb-4" @click="submitUser(true)"
            >Mask</v-btn
          >
          <v-btn outline color="error" class="mb-4" @click="submitUser(false)"
            >No Mask</v-btn
          >
        </v-card>
        <v-card class="mt-4 primary">
          <v-toolbar color="primary" flat>
            <h2>Mask Audits ({{ totalItems }})</h2>
            <v-spacer />
            <v-tooltip bottom>
              <v-btn flat icon medium @click="downloadData" slot="activator"
                ><v-icon medium>get_app</v-icon></v-btn
              >
              <span>Export Data</span>
            </v-tooltip>
          </v-toolbar>
          <v-data-table
            flat
            :headers="headers"
            class="primary mx-2"
            :items="allAudits"
            :total-items="totalItems"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.employee }}</td>
              <td class="text-xs-left">
                {{ props.item.compliant ? "Yes" : "No" }}
              </td>
              <td class="text-xs-left">
                {{ localizeDate(props.item.dateCreated, true) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import UserSearch from "@/components/app/UserSearch";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";
import { mapGetters, mapActions } from "vuex";
import exportMixin from "@/mixins/Export";

export default {
  name: "Masks",
  data() {
    return {
      reload: true,
      employee: false,
      headers: [
        { text: "Employee", value: "employee" },
        { text: "Compliant", value: "compliance" },
        { text: "Date Created", value: "dateCreated" }
      ],

      pagination: {
        rowsPerPage: 10,
        sortBy: "dateCreated",
        descending: true,
        page: 1
      }
    };
  },
  computed: {
    ...mapGetters({
      allAudits: "audits/getAllAudits",
      totalItems: "audits/getTotalAudits",
      exportData: "audits/getExportData"
    }),
    searchParams() {
      return {
        module: "mask",
        ...this.pagination,
        search: this.search || null,
        from: this.fromDate || null,
        to: this.toDate || null
      };
    }
  },
  watch: {
    pagination: {
      handler() {
        this.load(this.searchParams);
      },
      deep: true
    }
  },
  components: {
    UserSearch
  },
  async mounted() {
    await this.load();
  },

  destroyed() {
    this.$store.commit("audits/setAllAudits", []);
  },

  mixins: [LoginCheck, Common, exportMixin],

  methods: {
    ...mapActions({
      createAudit: "audits/create",
      getAudits: "audits/getAllAudits",
      getExportData: "audits/getExportData",
      showSnackbar: "app/setSnackbar"
    }),

    userSelected(e) {
      if (e) this.employee = e.split("(")[0];
    },

    async submitUser(isWearing) {
      if (this.employee) {
        await this.createAudit({
          module: "mask",
          body: {
            employee: this.employee,
            compliant: isWearing
          }
        });
        this.$refs.userSearch.select = false;
        this.employee = false;
        await this.load();
      } else {
        this.showSnackbar({
          text: "Please select a user!",
          color: "red"
        });
      }
    },

    async load() {
      this.getAudits(this.searchParams);
    },

    async downloadData() {
      await this.getExportData({
        rowsPerPage: -1,
        sortBy: "dateCreated",
        descending: true,
        module: "mask"
      });

      let filename = `mask-audit.csv`;

      let data = this.exportData.map(audit => {
        let table = {
          Employee: audit.employee.replace(/,/g, " ") || "",
          Mask: audit.compliant ? "YES" : "NO",
          Date: audit.dateCreated
            ? new Date(audit.dateCreated)
                .toLocaleDateString([], {
                  month: "2-digit",
                  day: "numeric",
                  year: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit"
                })
                .toString()
                .replace(",", " ")
            : ""
        };

        return table;
      });

      this.downloadCSV({
        filename: filename,
        selected: data
      });
    }
  }
};
</script>

<style></style>
